module.exports = __webpack_public_path__ + "static/media/profile-10.64455747.jpeg";